export const FORMATION = "FORMATION";
export const KNOW_MORE = "En savoir +";
export const TRACABILITE = "tracabilite";
export const JURIDIQUE = "juridique";
export const CONTENTIEUX = "contentieux";
export const QUOTE_DRAWER_WIDTH = '20vw';
export const FIRST_TIMEFRAME_KEY = "firstTimeframe";
export const PATIENT_STANDARD = "PATIENT_STANDARD";
export const SEARCH_SKIP = 0;
export const SEARCH_LIMIT = 60;